import { useEffect } from 'react'
import {
  ArrowDownCircle,
  ArrowRight,
  FileText,
  PlusCircle,
} from 'react-feather'
import Skeleton from 'react-loading-skeleton'
import { Col, Row } from 'reactstrap'

// Redux
import { persistor } from 'app/store'
import { useFetchSaldoQuery } from '../dashboardApiSlice'
//
import CustomButton from 'components/Buttons/CustomButton'
import CardBankAccount from 'components/CardBankAccount'
import Verification from 'features/private-views/verification/Verification'
import { useFetchWithdrawalQuery } from 'features/private-views/withdraw/withdrawApiSlice'
import {
  setAlertMsg,
  toggleAlert,
} from 'features/public-views/login/loginSlice'
import { useAbilityAccess } from 'hooks/useAbilityAccess'
import useIsMobile from 'hooks/useIsMobile'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useOutletContext } from 'react-router-dom'
import { BUSINESS_TOPUP, MANAGE } from 'utils/subjectActions'
import { addBalance, toggleSidebarWithdraw } from '../dashboardSlice'

const SectionCards = ({ templateName }) => {
  const isDefaultTemplate = templateName === 'DEFAULT' || templateName === 'HOMEWEAVERS';
  const colorUangBelanja = isDefaultTemplate ? '#2563EB' : undefined;
  const colorUangUsaha = isDefaultTemplate ? '#0891B2' : undefined;
  const colorTalangin = isDefaultTemplate ? '#EA580C' : undefined;
  const accessTopup = useAbilityAccess({
    action: MANAGE,
    subject: BUSINESS_TOPUP,
  })
  const dispatch = useDispatch()
  const { role } = useSelector((s) => s.auth)
  const { isLoading, isSuccess, data, isError } = useFetchSaldoQuery()
  const isMobile = useIsMobile()

  const profile = useOutletContext()
  const {
    data: dataWithdraw,
    isLoading: isLoadingWithdraw,
    isSuccess: isSuccessWithdraw,
  } = useFetchWithdrawalQuery()

  const navigate = useNavigate()
  const { isProcess } = useSelector((e) => e.withdraw)
  const { lateInvoice } = useSelector((s) => s.talanginInvoice)
  const toggle = () => dispatch(toggleSidebarWithdraw())

  useEffect(() => {
    if (isSuccess && data) {
      dispatch(addBalance(data))
    }
    if (isError) {
      persistor.purge()
      navigate('/login')
      dispatch(toggleAlert(true))
      dispatch(setAlertMsg('Ada masalah koneksi, silakan login kembali'))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isError, navigate, data, dispatch, isSuccess])

  const status = dataWithdraw?.items
    ?.map((item) => {
      if (item.status === 'Dalam Proses') {
        return 'Penarikan dalam proses'
      } else if (
        role === 'Staff' &&
        item.status === 'Menunggu Approval Admin'
      ) {
        return 'Penarikan menunggu approval admin'
      } else if (
        role === 'Admin' &&
        item.status === 'Menunggu Approval Admin'
      ) {
        return 'Ada penarikan membutuhkan approval'
      }
      return null // Return null for other cases
    })
    .filter((message) => message !== null)

  return (
    <div className="w-100 mt-4">
      {/* <h4 className="mb-4">
        {generateGreetings()}
        {profile?.isLoading ? (
          <LoadingAnimation size="sm" />
        ) : profile?.isSuccess ? (
          <>
            {`, `}
            {profile?.data?.makerData?.name}!
          </>
        ) : (
          <LoadingAnimation size="sm" />
        )}
      </h4> */}
      <Verification profile={profile} />
      <div>
        <div className="d-lg-flex">
          {/* MOBILE VIEW */}
          {isMobile && (
            <Row className="flex-nowrap overflow-auto hide-scrollbar gx-3 pb-2 mb-2" style={{ WebkitOverflowScrolling: 'touch' }}>
              <Col xs="10" sm="8" md="6" className="flex-shrink-0">
                {isLoading && !data ? (
                  <Skeleton height={130} style={{ marginBottom: '14px' }} />
                ) : (
                  <CardBankAccount
                    iconName={"old-icons-box-out"}
                    cardThemeColor={colorUangBelanja}
                    title="Uang Belanja"
                    btnTitle="Tambah"
                    btnIcon={<PlusCircle size={18} />}
                    bankAmount={data?.wallet1}
                    isLoading={isLoading}
                    isSuccess={isSuccess}
                    isDisable={
                      profile?.data?.ownerData?.status !== 'VERIFIED' ||
                      !accessTopup
                    }
                    handleClick={() => navigate('/topup')}
                    onClickHeader={() => navigate('/uang-belanja')}
                  />
                )}
              </Col>
              <Col xs="10" sm="8" md="6" className="flex-shrink-0">
                {isLoading && !data ? (
                  <Skeleton height={130} style={{ marginBottom: '14px' }} />
                ) : (
                  <CardBankAccount
                    iconName={"old-icons-box-in"}
                    cardThemeColor={colorUangUsaha}
                    title="Uang Usaha"
                    btnTitle="Lihat Uang Usaha"
                    btnIcon={<ArrowDownCircle size={18} />}
                    bankAmount={data?.wallet2}
                    isLoading={isLoading}
                    isSuccess={isSuccess}
                    isDisable={false}
                    handleClick={() => {
                      if (
                        dataWithdraw?.items?.some(
                          (wd) =>
                            wd?.status === 'Dalam Proses' ||
                            (role === 'Staff' &&
                              wd?.status === 'Menunggu Approval Admin') ||
                            (role === 'Admin' &&
                              wd?.status === 'Menunggu Approval Admin'),
                        )
                      ) {
                        toggle()
                      } else {
                        navigate('/penarikan-uang')
                      }
                    }}
                    isProcess={
                      isProcess ||
                      dataWithdraw?.items?.some(
                        (wd) =>
                          wd?.status === 'Dalam Proses' ||
                          (role === 'Staff' &&
                            wd?.status === 'Menunggu Approval Admin') ||
                          (role === 'Admin' &&
                            wd?.status === 'Menunggu Approval Admin'),
                      )
                    }
                    processMsg={status ? status?.[0] : ''}
                    noHover
                  />
                )}
              </Col>
              <Col xs="10" sm="8" md="6" className="flex-shrink-0 pe-4">
                {isLoading && !data ? (
                  <Skeleton height={130} style={{ marginBottom: '14px' }} />
                ) : (
                  <CardBankAccount
                    iconName={"old-icons-money-bill"}
                    cardThemeColor={colorTalangin}
                    title="Talangin"
                    btnTitle="Lihat Tagihan"
                    btnIcon={<FileText size={18} />}
                    bankAmount={data?.talangin}
                    isLoading={isLoading}
                    isSuccess={isSuccess}
                    isDisable={false}
                    handleClick={() => navigate('/tagihan-talangin')}
                    isProcess={lateInvoice?.allLate > 0}
                    processMsg={
                      'Ada tagihan jatuh tempo hari ini atau terlambat'
                    }
                    noHover
                  />
                )}
              </Col>
            </Row>
          )}
        </div>

        {/* DESKTOP VIEW */}
        {!isMobile && (
          <Row className="align-items-stretch">
            <Col md="4" className="mb-3">
              <CardBankAccount
                iconName={"old-icons-box-out"}
                cardThemeColor={colorUangBelanja}
                title="Uang Belanja"
                btnTitle="Tambah Saldo"
                btnIcon={<PlusCircle size={16} className="me-2" />}
                bankAmount={data?.wallet1}
                isLoading={isLoading}
                isSuccess={isSuccess}
                isDisable={
                  profile?.data?.ownerData?.status !== 'VERIFIED' ||
                  !accessTopup
                }
                handleClick={() => navigate('/topup')}
                onClickHeader={() => navigate('/uang-belanja')}
              />
            </Col>
            <Col md="4" className="mb-3">
              <CardBankAccount
                iconName={"old-icons-box-in"}
                cardThemeColor={colorUangUsaha}
                title="Uang Usaha"
                btnTitle="Lihat Uang Usaha"
                btnIcon={<ArrowDownCircle size={16} className="me-2" />}
                bankAmount={data?.wallet2}
                isLoading={isLoading}
                isSuccess={isSuccess}
                isDisable={false}
                handleClick={() => {
                  if (
                    dataWithdraw?.items?.some(
                      (wd) =>
                        wd?.status === 'Dalam Proses' ||
                        (role === 'Staff' &&
                          wd?.status === 'Menunggu Approval Admin') ||
                        (role === 'Admin' &&
                          wd?.status === 'Menunggu Approval Admin'),
                    )
                  ) {
                    toggle()
                  } else {
                    navigate('/penarikan-uang')
                  }
                }}
                isProcess={
                  isProcess ||
                  dataWithdraw?.items?.some(
                    (wd) =>
                      wd?.status === 'Dalam Proses' ||
                      (role === 'Staff' &&
                        wd?.status === 'Menunggu Approval Admin') ||
                      (role === 'Admin' &&
                        wd?.status === 'Menunggu Approval Admin'),
                  )
                }
                processMsg={status ? status?.[0] : ''}
              />
            </Col>
            <Col md="4" className="mb-3">
              <CardBankAccount
                iconName={"old-icons-money-bill"}
                cardThemeColor={colorTalangin}
                title="Talangin"
                btnTitle="Lihat Tagihan"
                btnIcon={<FileText size={16} className="me-2" />}
                bankAmount={data?.talangin}
                isLoading={isLoading}
                isSuccess={isSuccess}
                isDisable={false}
                handleClick={() => navigate('/tagihan-talangin')}
                isProcess={lateInvoice?.allLate > 0}
                processMsg={'Ada tagihan jatuh tempo hari ini atau terlambat'}
              />
            </Col>
          </Row>
        )}

        {/* CTA FOR MOBILE ONLY */}
        <div>
          {isMobile &&
            dataWithdraw?.items?.some(
              (wd) =>
                wd?.status === 'Dalam Proses' ||
                (role === 'Staff' &&
                  wd?.status === 'Menunggu Approval Admin') ||
                (role === 'Admin' && wd?.status === 'Menunggu Approval Admin'),
            ) && (
              <CustomButton
                block
                style={{
                  borderColor: '#FEB273',
                  backgroundColor: '#FFF6ED',
                  color: 'black',
                  minHeight: '38px',
                  fontSize: '12px',
                  marginBottom: '12px',
                }}
                onClick={() => {
                  if (
                    dataWithdraw?.items?.some(
                      (wd) =>
                        wd?.status === 'Dalam Proses' ||
                        (role === 'Staff' &&
                          wd?.status === 'Menunggu Approval Admin') ||
                        (role === 'Admin' &&
                          wd?.status === 'Menunggu Approval Admin'),
                    )
                  ) {
                    toggle()
                  } else {
                    navigate('/penarikan-uang')
                  }
                }}
              >
                <div className="d-flex justify-content-between align-items-center">
                  <span className="text-start flex-grow-1">
                    {status ? status?.[0] : ''}
                  </span>
                  <span className="fw-bold">
                    <ArrowRight size={18} />
                  </span>
                </div>
              </CustomButton>
            )}

          {/* TALANGIN CARD */}
          {isMobile && lateInvoice?.allLate > 0 && (
            <CustomButton
              block
              style={{
                borderColor: '#FEB273',
                backgroundColor: '#FFF6ED',
                color: 'black',
                minHeight: '38px',
                fontSize: '12px',
                marginBottom: '12px',
              }}
              onClick={() => navigate('/tagihan-talangin')}
            >
              <div className="d-flex justify-content-between align-items-center">
                <span className="text-start flex-grow-1">
                  Ada tagihan jatuh tempo hari ini atau terlambat
                </span>
                <span className="fw-bold">
                  <ArrowRight size={18} />
                </span>
              </div>
            </CustomButton>
          )}
        </div>
      </div>
    </div>
  )
}

export default SectionCards
